import React, { useRef } from 'react';
import c from 'classnames';

import useOnScreen from '../../hooks/useOnScreen';
import useScrollPosition from '../../hooks/useScrollPosition';

import './style.scss';

const StickyButtons = ({ children }) => {
  const ref = useRef();

  const getButtonSpecs = (prop) => (ref.current ? ref.current[prop] : 0);

  const getSidebarElementHeight = (queryParam) => {
    if (document.getElementById(queryParam)) {
      return document.getElementById(queryParam).clientHeight;
    }
    return null;
  };

  const buttonsAreVisible = useOnScreen(ref);
  const viewportHeight = window.innerHeight;
  const documentHeight = document.body.scrollHeight;
  const scrollPosition = useScrollPosition() + viewportHeight;
  const footerHeight = document.getElementById('footer').clientHeight;

  const buttonsOffsetTop = getButtonSpecs('offsetTop');
  const buttonsHeight = getButtonSpecs('clientHeight');

  const stopPoint = documentHeight - footerHeight - 60;
  const stopped = scrollPosition > stopPoint;

  const spacingContentSidebar = getSidebarElementHeight('sidebar') - getSidebarElementHeight('sidebar-content');
  const scrollPositionUntilButtons = viewportHeight + buttonsOffsetTop;

  // condenses calculations to boolean value to determine sticky or not
  const scrolledPassedButtons = scrollPosition > scrollPositionUntilButtons;
  const enoughSpaceForButtons = spacingContentSidebar > buttonsHeight;

  const classNames = c('StickyButtons', {
    'is-sticky': !stopped && !buttonsAreVisible && scrolledPassedButtons && enoughSpaceForButtons,
    'is-stopped': stopped && !buttonsAreVisible && enoughSpaceForButtons,
  });

  return (
    <div className={classNames} ref={ref}>
      <div className="StickyButtons__normal">
        {children}
      </div>
      <div className="StickyButtons__sticky">
        {children}
      </div>
    </div>
  );
};


export default StickyButtons;
